import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../utils/loadable';
import { isFuncComp } from '../../../components/common/Helpers/index';

const miniCartDueMonthly = Loadable(() => (isFuncComp() ? import('../FuncContainers/miniCartDueMonthly') : import('../containers/miniCartDueMonthly')));
export default MapTo('vcg/components/soe-home/react/common/miniCartDueMonthly')(miniCartDueMonthly);
